export const Approved = ({disabled = false, color = "#5EC394", size=10 }) => {
    if (disabled) {
        color="#A2AAAB"
    }
    return (
        <svg width={size} height={size} viewBox={`0 0 10 10`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.51601 5.00019C9.51601 7.4187 7.55542 9.37929 5.13691 9.37929C2.7184 9.37929 0.757812 7.4187 0.757812 5.00019C0.757812 2.58169 2.7184 0.621094 5.13691 0.621094C7.55542 0.621094 9.51601 2.58169 9.51601 5.00019ZM2.60217 4.95293L4.54101 6.93911L7.67169 3.75174L6.9718 3.05185L4.54101 5.53933L3.30206 4.25302L2.60217 4.95293Z" fill={color}/>
        </svg>
    )
}